import React from "react";

/* Numbered section heading e.g. "01. Purpose of These Guidelines" */
export function SectionHeading({ number, title }) {
  return (
    <div className="d-flex align-items-baseline gap-2 mb-3 sz-section-heading">
      {number && <span className="sz-section-number">{number}.</span>}
      <h2 className="sz-section-title mb-0">{title}</h2>
    </div>
  );
}

/* Left-bordered content wrapper used under every numbered section */
export function SectionBody({ children }) {
  return <div className="sz-section-body">{children}</div>;
}

/* Full numbered section: heading + bordered body + bottom divider */
export function NumberedSection({ number, title, children }) {
  return (
    <section className="sz-numbered-section">
      <SectionHeading number={number} title={title} />
      <SectionBody>{children}</SectionBody>
      <hr className="sz-divider" />
    </section>
  );
}

/* Plain (non-numbered) section heading, e.g. "Timeline Sharing" */
export function PlainHeading({ children }) {
  return <h2 className="sz-plain-title mb-3">{children}</h2>;
}

/* Blue info callout box */
export function InfoBox({ children, bold }) {
  return (
    <div className={`sz-info-box ${bold ? "fw-semibold" : ""}`}>{children}</div>
  );
}

/* Red/pink warning callout box */
export function WarningBox({ children }) {
  return <div className="sz-warning-box fw-semibold">{children}</div>;
}

/* Yellow caution callout box */
export function CautionBox({ children }) {
  return <div className="sz-caution-box fw-semibold">{children}</div>;
}

/* Grey outlined card used for sub-sections like "a. General Public Profile" */
export function GreyCard({ title, children }) {
  return (
    <div className="sz-grey-card">
      {title && <h5 className="sz-grey-card-title">{title}</h5>}
      {children}
    </div>
  );
}

/* Checkmark list item (blue check) */
export function CheckItem({ children }) {
  return (
    <li className="sz-check-item">
      <span className="sz-check-icon">✓</span>
      <span>{children}</span>
    </li>
  );
}

/* Prohibited / red exclamation list item */
export function ProhibitedItem({ children }) {
  return (
    <div className="sz-prohibited-item">
      <span className="sz-prohibited-bar" />
      <span>{children}</span>
    </div>
  );
}

/* Blue circular number badge, used in "About This User Guide" steps */
export function NumberCircle({ number, children }) {
  return (
    <div className="sz-number-circle-item">
      <span className="sz-number-circle">{number}</span>
      <span>{children}</span>
    </div>
  );
}

/* Colored pill badge, e.g. "ISSUE" */
export function Badge({ children, variant = "danger" }) {
  return <span className={`sz-badge sz-badge-${variant}`}>{children}</span>;
}
